// Mehrfachauswahl für die Pflegetabellen der Einstellungen (DCP-2228 Folge-Feature)
//
// Von der Mailing-Liste und der Vorlagen-Liste gemeinsam genutzt: die Funktionen kennen
// nur Zeichenketten als Kennung, also passen beide Fälle. Eine zweite Kopie wäre die,
// die den Sonderfall unten irgendwann verliert.
//
// Als reine Funktionen und nicht inline in der Tabelle, weil hier zwei Fehler
// wohnen, die man beim Ablesen nicht sieht:
//
//   * Bei leerer Tabelle wäre `ausgewählt === gesamt` rechnerisch wahr, und das
//     Kopf-Häkchen stünde auf „alle" — deshalb der Sonderfall 0.
//   * Nach dem Löschen (oder einem Import) bleiben Kennungen in der Auswahl,
//     die es nicht mehr gibt. Ein Massenlöschen zielt dann ins Leere, und die
//     „alle ausgewählt"-Rechnung kippt.

/** Zustand des Kopf-Häkchens. */
export type SelectionState = 'none' | 'some' | 'all';

export function selectionState(total: number, selectedCount: number): SelectionState {
  // Leere Tabelle: nichts auswählbar, also niemals „alle".
  if (total === 0 || selectedCount === 0) return 'none';
  return selectedCount >= total ? 'all' : 'some';
}

/** „Alle auswählen" schaltet um: erst alles, dann nichts. */
export function toggleAll(all: readonly string[], selected: readonly string[]): string[] {
  return selectionState(all.length, selected.length) === 'all' ? [] : [...all];
}

/** Eine Zeile an- oder abwählen. */
export function toggleOne(selected: readonly string[], label: string): string[] {
  return selected.includes(label)
    ? selected.filter((entry) => entry !== label)
    : [...selected, label];
}

/**
 * Entfernt Bezeichnungen aus der Auswahl, die es nicht mehr gibt.
 *
 * Läuft bei jedem Rendern gegen die frisch geladene Liste, nicht nur nach dem
 * eigenen Löschen: die Liste kann sich auch durch einen Import oder einen anderen
 * Benutzer verändert haben.
 */
export function pruneSelection(
  selected: readonly string[],
  available: readonly string[]
): string[] {
  const present = new Set(available);
  return selected.filter((label) => present.has(label));
}
